module.exports = __webpack_public_path__ + "static/media/default-avatar.ddd04898.jpg";